import { WebappsWithPulumiComponent } from './pulumi/components/webapps-with-pulumi/webapps-with-pulumi.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { PulumiProjectsListComponent } from './pulumi/components/pulumi-projects-list/pulumi-projects-list.component';
import { WhitelabelOptionsListComponent } from './whitelabel/components/whitelabel-options-list/whitelabel-options-list.component';
import { WhitelabelAppsListComponent } from './whitelabel/components/whitelabel-apps-list/whitelabel-apps-list.component';
import { WhitelabelCreateComponent } from './whitelabel/components/whitelabel-create/whitelabel-create.component';
import { WhitelabelPendingAppsListComponent } from './whitelabel/components/whitelabel-pending-apps-list/whitelabel-pending-apps-list.component';
import { AppComponent } from './app.component';
import { ConnectionsListComponent } from './nibo-whatsapp/components/connections-list/connections-list.component';
import { WhatsappOptionsComponent } from './nibo-whatsapp/components/whatsapp-options/whatsapp-options.component';
import { IntegrationTestComponent } from './nibo-whatsapp/components/integration-test/integration-test.component';
import { GlobalSettingsComponent } from './nibo-whatsapp/components/global-settings/global-settings.component';
import { ConnectionSettingsComponent } from './nibo-whatsapp/components/connection-settings/connection-settings.component';

const routes: Routes = [
  {
    path: 'whatsapp',
    component: WhatsappOptionsComponent,
    children: [
      {
        path: 'connections',
        component: ConnectionsListComponent
      },
      {
        path: 'connections/:connectionId/update',
        component: ConnectionSettingsComponent
      },
      {
        path: 'integration-test',
        component: IntegrationTestComponent
      },
      {
        path: 'global-settings',
        component: GlobalSettingsComponent
      }
    ]
  },
  { 
    path: 'pulumi',
    component: PulumiProjectsListComponent,
    canActivate: [MsalGuard],
    children: [
      {
        path: ':repositoryName',
        component: WebappsWithPulumiComponent,
        canActivate: [MsalGuard]      
      }    
    ]  
  },
  { 
    path: 'whitelabel',
    component: WhitelabelOptionsListComponent,
    canActivate: [MsalGuard],
    children: [
      {
        path: 'create',
        component: WhitelabelCreateComponent,
        canActivate: [MsalGuard]
      },
      {
        path: 'edit/:accountantId',
        component: WhitelabelCreateComponent,
        canActivate: [MsalGuard]
      },
      {
        path: 'edit/hubspot/:accountantId',
        component: WhitelabelCreateComponent,
        canActivate: [MsalGuard]
      },
      {
        path: 'list',
        component: WhitelabelAppsListComponent ,
        canActivate: [MsalGuard]
      },
      {
        path: 'pending',
        component: WhitelabelPendingAppsListComponent ,
        canActivate: [MsalGuard]
      },
    ]
  }
  
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    // 'enabled' foi removido no Angular 14; o equivalente e 'enabledBlocking'.
    initialNavigation: 'enabledBlocking'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
